import React, { useRef } from 'react';

import { quizMessages } from '../../../../translates/quizMessages';
import { blindMapIntroductionDismissed } from '../../../actions/contentItemActions';
import { IntroductionModal } from '../../../components/introduction/IntroductionModal';
import { useIntlReexport } from '../../../hooks/useIntlReexport';
import { useStudentDispatch } from '../../../hooks/useStudentDispatch';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSTransition } from 'react-transition-group';

export const BlindMapIntroduction: React.FC = () => {
  const [dismissed, setDismissed] = React.useState(false);
  const { formatMessage } = useIntlReexport();
  const ref = useRef(null);
  const dispatch = useStudentDispatch();

  const handleClose = (dontShowAgain: boolean) => {
    setDismissed(true);
    dispatch(blindMapIntroductionDismissed(dontShowAgain));
  };

  return (
    <CSSTransition nodeRef={ref} classNames="fade" timeout={450} in={!dismissed} unmountOnExit={true} appear={true}>
      <IntroductionModal
        ref={ref}
        onClick={handleClose}
        graphic={
          <div>
            <FontAwesomeIcon icon={light('search')} size="2x" />
          </div>
        }
        text={formatMessage(quizMessages.clickLocation)}
        displayDontShowAgain={true}
        buttonLabel={formatMessage(quizMessages.go)}
        header={formatMessage(quizMessages.blindTest)}
      />
    </CSSTransition>
  );
};
